import * as React from 'react';
import { cn } from '@src/design-system/helpers';

const TableHeader = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    className={cn(className)}
    {...props}
  />
));

TableHeader.displayName = 'TableHeader';

export default TableHeader;
